// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/oxygen-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/oxygen-equipment/oxygen-equipment.js';

mount([g0]);
